export enum ModifierKeyEnum {
  None,
  Shift,
  Ctrl,
  Alt,
  CtrlShift,
  AltShift
}
